const cypressAuth0Client = ({ body }) => ({
  async getUser() {
    return new Promise((resolve) => {
      resolve(body.decodedToken.user);
    });
  },
  async getTokenSilently() {
    return new Promise((resolve) => {
      resolve(body.access_token);
    });
  },
  async isAuthenticated() {
    return new Promise((resolve) => {
      resolve(body !== null);
    });
  },
  async logout() {
    return new Promise((resolve) => resolve());
  },
});

export default cypressAuth0Client;
